import React from "react";
import "./index.scss";

import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { ApplicationState } from "../../store";
import { User } from "../../store/ducks/user/types";
import * as UserActions from "../../store/ducks/user/actions";
import { Param } from "../../store/ducks/param/types";
import * as ParamActions from "../../store/ducks/param/actions";

import Footer from "../../components/Footer";
import SocialButton from "../../components/SocialButton";
import Api from "../../services/api";
import config from "../../config.json";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";

import logoPreta from "../../assets/Images/domakoski-preta.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEyeSlash, faEye } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons";

interface StateProps {
  user: User;
  param: Param;
}

interface DispatchProps {
  doLogin(user: User): void;
  setParam(param: Param): void;
}

interface OwnProps {}

type Props = StateProps & DispatchProps & OwnProps;

class Contato extends React.Component<Props> {
  api: any = null;
  state: any = null;

  constructor(props) {
    super(props);
    this.api = new Api();
    this.state = {
      redirect: null,
      isLoading: false,
      email: "",
      nome: "",
      telefone: "",
      mensagem: "",
      hasError: false,
      hasErrorTitle: "",
      hasErrorMsg: "",
      hasSuccess: false,
      hasSuccessTitle: "",
      hasSuccessMsg: "",
      hidden: true,
    };

    this.toggleShow = this.toggleShow.bind(this);
  }

  toggleShow() {
    this.setState({ hidden: !this.state.hidden });
  }

  // FAZ TRATAMENTO DA SUBMISSAO FORM DE LOGIN
  private async handleSubmit() {
    const self = this;
    let timeout = 5000;

    if (!this.state.email) {
      self.setState(
        {
          hasError: true,
          hasErrorTitle: "Formulário incompleto",
          hasErrorMsg: "Por favor, digite seu e-mail para continuar.",
        },
        () => {
          setTimeout(() => self.setState({ hasError: false }), timeout);
        }
      );
      return;
    }

    if (!this.state.nome) {
      self.setState(
        {
          hasError: true,
          hasErrorTitle: "Formulário incompleto",
          hasErrorMsg: "Por favor, digite seu nome para continuar.",
        },
        () => {
          setTimeout(() => self.setState({ hasError: false }), timeout);
        }
      );
      return;
    }

    self.setState({
      isLoading: true,
      hasErrorTitle: false,
      hasErrorMsg: "",
      hasSuccess: false,
      hasSuccessTitle: "",
      hasSuccessMsg: "",
    });

    let param = {
      nome: self.state.nome,
      email: self.state.email,
      telefone: self.state.telefone,
      mensagem: self.state.mensagem,
    };

    try {
      const { data } = await self.api.post("/contact", param);

      if (!data.status) {
        throw new Error(data.msg);
      } else {
        self.setState(
          {
            hasSuccess: false,
            hasSuccessTitle: "Sucesso",
            hasSuccessMsg: "Mensagem enviada com sucesso",
          },
          () => {
            setTimeout(() => self.setState({ hasSuccess: false }), timeout);
          }
        );
      }
    } catch (e) {
      // console.error(e);
      self.setState(
        {
          hasError: true,
          hasErrorTitle: "Ops",
          hasErrorMsg:
            "Não foi possível enviar a mensagem, por favor tente novamente",
        },
        () => {
          setTimeout(() => self.setState({ hasError: false }), timeout);
        }
      );
    } finally {
      self.setState({ isLoading: false });
    }
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }

    return (
      <>
        {/* <Header/> */}

        <section className="user-page sign-in-session">
          <Row className="user-row-container">
            <Col lg={8} className="user-hero">
              <div className="user-overlay" />
              <article className="cta">
                <h2> Gostaria de aprender novas receitas? </h2>
                <p>
                  {" "}
                  Confira nossa lista de receitas fáceis e rápidas para preparar
                  com nossos produtos!{" "}
                </p>
                <Button className="btn-primary-action btn-user">
                  {" "}
                  <a href="/receitas"> Conferir </a>{" "}
                </Button>
              </article>
            </Col>

            <Col lg={4} className="user-form-col">
              <div className="user-form-container">
                <a href="/" title="Voltar para a Home" className="text-center">
                  {" "}
                  <img
                    src={logoPreta}
                    className="logo-preta"
                    alt="logo Domakoski"
                  />{" "}
                </a>
                <h1> Fale Conosco </h1>

                {this.state.hasError && (
                  <div className="alert alert-danger mb-0 mt-3">
                    <strong> {this.state.hasErrorTitle} </strong>
                    <br />
                    {this.state.hasErrorMsg}
                  </div>
                )}

                {this.state.hasSuccess && (
                  <div className="alert alert-success mb-0 mt-3">
                    <strong> {this.state.hasSuccessTitle} </strong>
                    <br />
                    {this.state.hasSuccessMsg}
                  </div>
                )}

                <Form className="w-100 user-login-form">
                  <Form.Group
                    controlId="formGridEmail"
                    className="user-input-container"
                  >
                    <Form.Label> Seu Nome </Form.Label>
                    <Form.Control
                      size="lg"
                      type="text"
                      placeholder="Nome"
                      className={`user-input input-border ${
                        this.state.hasError ? "input-error" : ""
                      }`}
                      value={this.state.nome}
                      onChange={(event) =>
                        this.setState({ nome: event.target.value })
                      }
                      required
                    />
                  </Form.Group>
                  <Form.Group
                    controlId="formGridEmail"
                    className="user-input-container"
                  >
                    <Form.Label> Seu Email </Form.Label>
                    <Form.Control
                      size="lg"
                      type="email"
                      placeholder="Email"
                      className={`user-input input-border ${
                        this.state.hasError ? "input-error" : ""
                      }`}
                      value={this.state.email}
                      onChange={(event) =>
                        this.setState({ email: event.target.value })
                      }
                      required
                    />
                  </Form.Group>
                  <Form.Group
                    controlId="formGridEmail"
                    className="user-input-container"
                  >
                    <Form.Label> Seu Telefone </Form.Label>
                    <Form.Control
                      size="lg"
                      type="tel"
                      placeholder="Telefone"
                      className={`user-input input-border ${
                        this.state.hasError ? "input-error" : ""
                      }`}
                      value={this.state.telefone}
                      onChange={(event) =>
                        this.setState({ telefone: event.target.value })
                      }
                    />
                  </Form.Group>
                  <Form.Group
                    controlId="formGridEmail"
                    className="user-input-container"
                  >
                    <Form.Label> Mensagem </Form.Label>
                    <Form.Control
                      size="lg"
                      type="textarea"
                      placeholder="Mensagem"
                      className={`user-input input-border ${
                        this.state.hasError ? "input-error" : ""
                      }`}
                      value={this.state.mensagem}
                      onChange={(event) =>
                        this.setState({ mensagem: event.target.value })
                      }
                      as="textarea"
                      rows={4}
                      required
                    />
                  </Form.Group>
                </Form>
                <span className="actions-btn-wrapper">
                  <input
                    type="submit"
                    value="Enviar"
                    className="btn-primary-action btn-user"
                    title="Enviar"
                    onClick={this.handleSubmit.bind(this)}
                  />
                </span>
              </div>
            </Col>
          </Row>
        </section>

        <Footer />
      </>
    );
  }
}

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user.data,
  param: state.param.data,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ ...UserActions, ...ParamActions }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Contato);
